import React from 'react';
import { waveform_array, waveform_is_bought } from '../../utils/Waveform_array';
import {
  WaveformContainer,
  WaveformChunkBar,
  ChunckBarBoughtInfo,
  WaveformChunkContainer
} from '../../styles/Waveform.styled';

import { printEthAccount } from '../../utils/strings';

const Waveform = () => {
  return (
    <WaveformContainer>
      {waveform_array.map((element, index) => {
        return (
          <WaveformChunkContainer key={index * index * index + 2}>
            <WaveformChunkBar
              key={index}
              barHeight={waveform_array[index]}
              isBought={waveform_is_bought[index]}
              data-id={index}
            ></WaveformChunkBar>
            {waveform_is_bought[index] ? (
              <ChunckBarBoughtInfo key={index * index + 1}>
                Owned by : <br />
                <a
                  href="https://ropsten.etherscan.io/address/0x5c5ca3a3396dc2927ca9aaf1ee427c9859085f41"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {printEthAccount(
                    '0x5c5ca3a3396dc2927ca9aaf1ee427c9859085f41'
                  )}
                </a>
                <br />
                <i>"Love this DigChunk ! Thank you RMZ"</i>
              </ChunckBarBoughtInfo>
            ) : null}
          </WaveformChunkContainer>
        );
      })}
    </WaveformContainer>
  );
};

export default Waveform;
